// Phase 89B.1 — shared constants + pure helpers for the Match Performance workspace.
import { ThumbsUp, AlertTriangle, Circle } from 'lucide-react';

export const ASSESSMENTS = [
  { value: 'positive', label: 'Positive', icon: ThumbsUp, cls: 'bg-emerald-100 text-emerald-800 border-emerald-200', dot: 'bg-emerald-500' },
  { value: 'needs_improvement', label: 'Needs Improvement', icon: AlertTriangle, cls: 'bg-amber-100 text-amber-800 border-amber-200', dot: 'bg-amber-500' },
  { value: 'neutral', label: 'Neutral', icon: Circle, cls: 'bg-slate-100 text-slate-700 border-slate-200', dot: 'bg-slate-400' },
];
export const ASS_MAP = Object.fromEntries(ASSESSMENTS.map(a => [a.value, a]));

// Mirrors backend OBSERVATION_CATEGORIES (structural; not the configurable tag taxonomy).
export const CATEGORIES = [
  'In Possession', 'Out of Possession', 'Transition to Attack', 'Transition to Defence',
  'Set Pieces', 'Goalkeeping', 'Physical', 'Mental / Behavioural',
];

export const STAT_GROUPS = [
  { title: 'Passing', group: 'technical', fields: [
    ['passes_attempted', 'Attempted'], ['passes_completed', 'Completed'], ['passes_failed', 'Failed'],
    ['forward_passes', 'Forward'], ['backward_passes', 'Backward'], ['lateral_passes', 'Lateral'],
    ['progressive_passes', 'Progressive'], ['key_passes', 'Key passes'],
  ]},
  { title: 'Possession', group: 'technical', fields: [
    ['ball_losses', 'Ball losses'], ['dispossessions', 'Dispossessions'], ['recoveries', 'Recoveries'],
  ]},
  { title: 'Carrying / 1v1', group: 'technical', fields: [
    ['dribbles_attempted', 'Dribbles attempted'], ['dribbles_successful', 'Dribbles successful'],
    ['progressive_carries', 'Progressive carries'],
  ]},
  { title: 'Final Third', group: 'technical', fields: [
    ['shots', 'Shots'], ['shots_on_target', 'Shots on target'], ['chances_created', 'Chances created'],
    ['crosses', 'Crosses'],
  ]},
  { title: 'Defensive', group: 'defensive', fields: [
    ['tackles_attempted', 'Tackles attempted'], ['tackles_won', 'Tackles won'], ['interceptions', 'Interceptions'],
    ['recoveries', 'Recoveries'], ['defensive_duels', 'Defensive duels'], ['defensive_duels_won', 'Def. duels won'],
    ['aerial_duels', 'Aerial duels'], ['aerial_duels_won', 'Aerial duels won'], ['blocks', 'Blocks'],
    ['clearances', 'Clearances'], ['fouls_committed', 'Fouls committed'], ['fouls_won', 'Fouls won'],
    ['pressing_actions', 'Pressing actions'],
  ]},
];

export const DERIVED_LABELS = {
  pass_completion_pct: 'Pass completion',
  dribble_success_pct: 'Dribble success',
  shot_accuracy_pct: 'Shot accuracy',
  tackle_success_pct: 'Tackle success',
  defensive_duel_win_pct: 'Defensive duel win',
  aerial_duel_win_pct: 'Aerial duel win',
};

export const emptyEvidence = () => ({ source: 'Veo', timestamp: '', url: '', clip_url: '', label: '' });
export const emptyForm = () => ({
  timestamp: '', period: '', category: '', development_tag_ids: [],
  assessment: 'needs_improvement', observation: '', evidence: [],
});

export function buildStatsDraft(perf) {
  const d = {};
  ['technical', 'defensive', 'physical'].forEach(group => {
    const g = (perf && perf[group]) || {};
    Object.entries(g).forEach(([k, v]) => { if (v !== null && v !== undefined) d[`${group}.${k}`] = String(v); });
  });
  return d;
}

export function buildStatsPayload(draft, perf) {
  const groups = { technical: {}, defensive: {} };
  STAT_GROUPS.forEach(g => {
    g.fields.forEach(([key]) => {
      const dk = `${g.group}.${key}`;
      const raw = draft[dk];
      const had = perf?.[g.group]?.[key] !== null && perf?.[g.group]?.[key] !== undefined;
      if (raw === '' || raw === undefined) {
        if (had) groups[g.group][key] = null;  // cleared → explicit null
      } else {
        groups[g.group][key] = Number(raw);
      }
    });
  });
  const payload = {};
  if (Object.keys(groups.technical).length) payload.technical = groups.technical;
  if (Object.keys(groups.defensive).length) payload.defensive = groups.defensive;
  return payload;
}
